export const c_drawer__panel_md_FlexBasis_min = {
  "name": "--pf-v6-c-drawer__panel--md--FlexBasis--min",
  "value": "1.5rem",
  "var": "var(--pf-v6-c-drawer__panel--md--FlexBasis--min)"
};
export default c_drawer__panel_md_FlexBasis_min;